<template>
  <info-modal :title="subtitle" @btn-click="onRead" btn-text="我已阅读">
    <div>
      <div class="modal-content-loading" v-if="isLoading">加载中...</div>
      <div v-if="!isLoading" v-html="detail"></div>
    </div>
  </info-modal>
</template>
<script>
import infoModal from '@/components/member/infoModal'
export default {
  name: 'apply-modal',
  components: {
    infoModal
  },
  props: {
    category: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      detail: '',
      subtitle: '',
      isLoading: true
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.isLoading = true

      this.$fetch('/api/CmsCategory/GetCategoryInfo', {
        cateNo: this.category
      }).then(result => {
        this.isLoading = false
        if (result) {
          this.detail = result.DetailDesc
          this.subtitle = result.Title
          console.log('trigger load-complete event.')
          this.$emit('load-complete')
        }
      })
    },
    onRead() {
      this.$emit('read')
    }
  }
}
</script>

<style lang="less">
.modal-content-loading {
  text-align: center;
  padding: 30px 0;
  font-size: 13px;
}
</style>
